export var raTourLanguageEnglish = {
    'ra-tour': {
        action: {
            last: 'Last',
            next: 'Next',
            skip: 'Skip',
            open: 'Open the dialog',
        },
    },
};
